import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from './ui/PageHeader';
import PageBody from './ui/PageBody';
import IconButton from './ui/IconButton';
import { buildPublicationMeta } from '../utils/publicationMeta';

function ArticleView({
  article,
  isArchived = false,
  canRestore = false,
  isEditing = false,
  onStartEditing,
  isFavorite = false,
  onToggleFavorite,
  onRestore,
  children,
  onArchive
}) {
  const { t, i18n } = useTranslation();
  const parent = article.navigation?.parent;

  const eyebrow = isArchived
    ? article.department?.name
    : (
      <>
        <div className="article-back-link">
          <Link to="/articles">
            <i className="fa-solid fa-arrow-left" aria-hidden="true" />
            {t('articlesPage.backToArticles')}
          </Link>
        </div>

        {parent && (
          <Link to={`/article/${parent.article_id}`}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true" />
            {parent.title || t('articlePage.parentArticleFallback')}
          </Link>
        )}
      </>
    );

  // While editing, the form below owns everything but the title.
  const actions = !isEditing && (

    <div className="page-header__actions">
      {article.canEdit && (
        <>
          <IconButton
            className="article-edit-button"
            icon="fa-solid fa-pen-to-square"
            label={t('articlePage.editButtonLabel')}
            onClick={onStartEditing}
          />

          <IconButton
            className="article-edit-button"
            icon="fa-solid fa-trash"
            label={t('articlePage.deleteArchive')}
            onClick={onArchive}
          />
        </>
      )}

      <IconButton
        className={`article-edit-button${isArchived && !canRestore ? ' is-disabled' : ''
          }`}
        icon={isArchived ? 'fa-solid fa-box-open' : 'fa-solid fa-star'}
        label={
          isArchived
            ? t('articlesPage.restore')
            : t(isFavorite ? 'favorites.remove' : 'favorites.add')
        }
        active={!isArchived && isFavorite}
        onClick={
          isArchived
            ? (canRestore ? onRestore : undefined)
            : onToggleFavorite
        }
        disabled={isArchived && !canRestore}
      />
    </div>
  );

  return (
    <>
      <PageHeader
        eyebrow={eyebrow}
        title={article.title}
        department={!isArchived ? article.department?.name : null}
        actions={actions}
        description={!isEditing && article.summary}
        meta={isEditing ? [] : buildPublicationMeta(article, t, i18n.language)}
        tags={isEditing ? [] : article.tags}
        condensed={isEditing}
        landscape={isEditing ? true : 'behind'}
      />

      <PageBody className="page-body--split">
        {children}
      </PageBody>
    </>
  );
}

export default ArticleView;
